/* Brainrot Drinks — formulaire liste prioritaire (amelioration progressive)
   ---------------------------------------------------------------------------
   Le formulaire fonctionne SANS JavaScript : e-mail + prenom + consentement
   marketing sont transmis nativement a Shopify.

   Ce script ajoute une seule chose : il encode les preferences facultatives
   (pays, format de pack, saveurs) dans la valeur de la case de consentement,
   qui porte le nom « contact[tags] ». Shopify enregistre alors ces preferences
   sous forme d'etiquettes client.

   Pourquoi cette case et pas un champ cache ? Parce qu'une case decochee
   n'envoie rien du tout. Sans consentement, aucune etiquette marketing n'est
   creee — c'est la garantie RGPD par construction.

   Aucun appel reseau, aucun cookie, aucun traceur.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (!window.customElements || !window.HTMLElement) return;

  // Normalise un libelle en etiquette Shopify : minuscules, sans accents,
  // sans virgule (la virgule separe les etiquettes).
  function slug(value) {
    return String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  class BrainrotWaitlist extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.consent = this.querySelector('[data-consent]');
      if (!this.form || !this.consent) return;

      this.baseTags = (this.consent.getAttribute('data-base-tags') || '')
        .split(',')
        .map(function (t) { return t.trim(); })
        .filter(Boolean);

      this.form.addEventListener('submit', this.onSubmit.bind(this));

      // Composition recette par recette (facultative selon la section) :
      // total affiche en direct, et au moins un choix exige a l'envoi.
      this.composition = this.querySelector('[data-composition]');
      this.composeError = this.querySelector('[data-compose-error]');
      if (this.composition) {
        this.composition.addEventListener('change', this.updateTotal.bind(this));
        this.updateTotal();
      }

      // Apres soumission, Shopify recharge la page. On amene le lecteur
      // (y compris lecteur d'ecran) sur le message de retour.
      var alertEl = this.querySelector('[data-form-alert]');
      if (alertEl) {
        alertEl.setAttribute('tabindex', '-1');
        alertEl.focus({ preventScroll: false });
      }
    }

    collectPreferences() {
      var tags = [];

      this.querySelectorAll('[data-pref]').forEach(function (node) {
        var prefix = node.getAttribute('data-pref');
        var isChoice = node.type === 'checkbox' || node.type === 'radio';

        if (isChoice && !node.checked) return;
        if (!node.value) return;

        tags.push(prefix + '-' + slug(node.value));
      });

      return tags;
    }

    recipeTotal() {
      var total = 0;
      this.querySelectorAll('.br-compose__qty').forEach(function (select) {
        total += parseInt(select.value, 10) || 0;
      });
      return total;
    }

    updateTotal() {
      var total = this.recipeTotal();
      var out = this.composition.querySelector('[data-compose-total]');
      var template = (out && out.getAttribute('data-template')) || 'Total : [total]';
      if (out) out.textContent = total > 0 ? template.replace('[total]', total) : '';
      if (total > 0 && this.composeError) this.composeError.hidden = true;
    }

    hasChoice() {
      var pack = this.querySelector('input[data-pref="pack"]:checked');
      return (pack && pack.value) || this.recipeTotal() > 0;
    }

    prepareCheckout() {
      this.form.querySelectorAll('select[name], input[type="radio"][name]').forEach(function (field) {
        if (field.tagName === 'SELECT') field.disabled = !field.value;
        else if (!field.value) field.disabled = true;
      });

      // Total de la reservation : Pack decouverte (« 32 canettes ») + recettes.
      var pack = this.querySelector('input[data-pref="pack"]:checked');
      var total = this.recipeTotal() + ((pack && parseInt(pack.value, 10)) || 0);
      var totalField = this.form.querySelector('[data-compose-total-field]');
      if (totalField) {
        totalField.value = total > 0 ? String(total) : '';
        totalField.disabled = total === 0;
      }

      // Retour arriere depuis le paiement : les champs redeviennent modifiables.
      var form = this.form;
      window.addEventListener('pageshow', function () {
        form.querySelectorAll('[disabled]').forEach(function (field) {
          if (!field.hasAttribute('data-compose-total-field')) field.disabled = false;
        });
      }, { once: true });
    }

    onSubmit(event) {
      if (this.composition && !this.hasChoice()) {
        event.preventDefault();
        if (this.composeError) {
          this.composeError.hidden = false;
          this.composeError.setAttribute('tabindex', '-1');
          this.composeError.focus();
        }
        return;
      }

      // Mode « commande a 0 € » : le formulaire GET devient un lien de panier.
      // On retire les choix vides pour garder des attributs de commande lisibles.
      if (this.form.getAttribute('data-mode') === 'checkout') {
        this.prepareCheckout();
        return;
      }

      // Case decochee : on ne touche a rien, rien ne partira.
      if (!this.consent.checked) return;

      var tags = this.baseTags.concat(this.collectPreferences());

      // Mode reservation : l'abonnement marketing est une case distincte,
      // facultative. « newsletter » n'est ajoutee que si elle est cochee.
      var marketing = this.querySelector('[data-marketing]');
      if (marketing && marketing.checked) tags.push('newsletter');

      // Deduplication defensive, puis reassemblage.
      var seen = Object.create(null);
      var unique = tags.filter(function (t) {
        if (seen[t]) return false;
        seen[t] = true;
        return true;
      });

      this.consent.value = unique.join(',');
    }
  }

  if (!window.customElements.get('brainrot-waitlist')) {
    window.customElements.define('brainrot-waitlist', BrainrotWaitlist);
  }

  // Les tuiles « Choisis ton pack » portent data-br-pack : un clic preselectionne
  // le format correspondant dans le formulaire, puis l'ancre fait defiler.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-br-pack]');
    if (!trigger) return;
    var wanted = trigger.getAttribute('data-br-pack');
    document.querySelectorAll('brainrot-waitlist input[data-pref="pack"]').forEach(function (radio) {
      if (radio.value === wanted) radio.checked = true;
    });
    document.querySelectorAll('[data-compose-error]').forEach(function (el) { el.hidden = true; });
  });
})();
